<template>
    <div>
        <div class="row" :class="{'disabled' : !active}">
          <div class="col-md-8">
            <p class="h3 reduce-margin">
              <template v-if="type == 'shipping'">Delivery Address</template>
              <template v-else>Card Holder Address</template>
            </p>
            <template v-if="!manual && addresses.length && active && editing">
              <p>Choose a delivery address</p>
            </template>
          </div>
          <template v-if="addresses.length && active && editing">
            <div class="col-md-4 text-right" :class="{ 'col-md-4' : type == 'shipping', 'col-md-4' : type == 'billing' } ">
            <button @click="goManual" class="btn btn-sm btn-grey" v-if="!manual">Use a different address</button>
            <button @click="manual = false" class="btn btn-sm btn-grey" v-else>Use account address</button>
            </div>
          </template>
          <template v-if="type == 'billing' && editing && active && manual && enableSameShippingToggle">
            <div class="col-md-4 text-right">
              <div class="shipping_toggle">
                  <label class="default-switch">
                      <input type="checkbox" v-model="useShipping">
                      <span class="slider round"></span>
                  </label>
                  <span>Use shipping address</span>
                </div>
            </div>
          </template>
        </div>
        <template v-if="active">
          <template v-if="!editing">
            <button class="btn btn-xs btn-grey btn--position-right" @click="editing = true">Change details</button>
            <div class="row">
              <div class="col-md-12">
                <strong>{{ address.firstname }} {{ address.lastname }}</strong><br>
                <span v-if="address.company_name">{{ address.company_name }} <br></span>
                {{ address.address }},
                <span v-if="address.address_two"><br> {{ address.address_two }},</span>
                <span v-if="address.address_three"><br> {{ address.address_three }},</span>
                <br> {{ address.city }}, <br>
                {{ address.county }}, <br>
                {{ address.zip }}, <br>
                {{ address.country }}<span v-if="address.phone">, <br></span>
                {{ address.phone}}<span v-if="address.email">,</span> {{ address.email }}
              </div>
            </div>
          </template>
          <template v-else>
            <template v-if="manual || !addresses.length">
            <div class="row">
                <div class="col-xs-12 col-md-6">
                  <div class="form-group">
                    <label :for="type + '_firstname'">First Name</label>
                    <input :id="type + '_firstname'" type="text" class="form-control" v-model="address.firstname">
                    <span class="text-danger" v-for="(error, index) in getErrors('firstname')" :key="index">{{ error }}</span>
                  </div>
                </div>
                <div class="col-xs-12 col-md-6">
                  <div class="form-group">
                    <label :for="type + '_lastname'">Last Name</label>
                    <input :id="type + '_lastname'" type="text" class="form-control" v-model="address.lastname">
                    <span class="text-danger" v-for="(error, index) in getErrors('lastname')" :key="index">{{ error }}</span>
                  </div>
                </div>
            </div>
            <div class="row">
                <div class="col-xs-12 col-md-12">
                  <div class="form-group">
                    <label :for="type + '_company_name'">Company Name <span class="text-muted">(Optional)</span></label>
                    <input :id="type + '_company_name'" type="text" class="form-control" v-model="address.company_name">
                    <span class="text-danger" v-for="(error, index) in getErrors('company_name')" :key="index">{{ error }}</span>
                  </div>
                </div>
            </div>
            <div class="row">
              <div class="col-xs-12 col-md-6">
                <div class="form-group">
                  <label :for="type + '_postcode'">Post Code</label>
                  <div class="input-group">
                    <input :id="type + '_postcode'" type="text" class="form-control" v-model="address.zip">
                    <span class="input-group-btn">
                    <button class="btn btn-sm btn-blue" @click="lookup">Find address</button>
                    </span>
                  </div>
                  <span class="text-danger" v-for="(error, index) in getErrors('zip')" :key="index">{{ error }}</span>
                </div>
              </div>
              <div class="col-xs-12 col-md-6">
                <div v-if="lookups.length">
                  <label :for="type + '_address_picker'">Select an address</label>
                  <select :id="type + '_address_picker'" class="form-control" @change="applyLookup">
                        <option value readonly>Select address</option>
                        <option v-for="(lookup, index) in lookups" :key="index" :value="index">
                        {{ lookup.line_1 }}, {{ lookup.line_2 }},<span v-if="lookup.line_3">{{ lookup.line_3 }},</span> {{ lookup.district }}, {{ lookup.county }}
                        </option>
                  </select>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-xs-12">
                <label :for="type + '_address'">Address</label>
              </div>
              <div class="col-xs-12 col-md-4">
                <div class="form-group">
                  <input :id="type + '_address'" type="text" class="form-control" v-model="address.address">
                  <span class="text-danger" v-for="(error, index) in getErrors('address')" :key="index">{{ error }}</span>
                </div>
              </div>
              <div class="col-xs-12 col-md-4">
                <div class="form-group">
                  <input type="text" class="form-control" v-model="address.address_two">
                  <span class="text-danger" v-for="(error, index) in getErrors('address_two')" :key="index">{{ error }}</span>
                </div>
              </div>
              <div class="col-xs-12 col-md-4">
                <div class="form-group">
                  <input type="text" class="form-control" v-model="address.address_three">
                  <span class="text-danger" v-for="(error, index) in getErrors('address_three')" :key="index">{{ error }}</span>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-xs-12 col-md-4">
                <div class="form-group">
                  <label :for="type + '_towncity'">Town/City</label>
                  <input :id="type + '_towncity'" type="text" class="form-control" v-model="address.city">
                  <span class="text-danger" v-for="(error, index) in getErrors('city')" :key="index">{{ error }}</span>
                </div>
              </div>
              <div class="col-xs-12 col-md-4">
                <div class="form-group">
                  <label :for="type + '_county'">County</label>
                  <input :id="type + '_county'" type="text" class="form-control" v-model="address.county">
                  <span class="text-danger" v-for="(error, index) in getErrors('county')" :key="index">{{ error }}</span>
                </div>
              </div>
              <div class="col-xs-12 col-md-4">
                <div class="form-group">
                  <label :for="type + '_country'">Country</label>
                  <select :id="type + '_country'" class="form-control" v-model="address.country">
                      <option readonly value="null">Select Country</option>
                      <option value="United Kingdom">United Kingdom</option>
                  </select>
                  <span class="text-danger" v-for="(error, index) in getErrors('country')" :key="index">{{ error }}</span>
                </div>
              </div>
            </div>
            </template>
            <template v-else>
              <div class="row">
                <div class="col-xs-12 col-md-4" v-for="(address, index) in addresses" :key="index">
                    <label class="addres-choice-label" :class="{ 'choice-active': addressId == address.id }">
                      <p><strong>{{ address.firstname }} {{ address.lastname }}</strong></p>
                      <p>
                        {{ address.address }}<br>
                        {{ address.address_two }}<br>
                        <span v-if="address.address_three">{{ address.address_three }}<br></span>
                        {{ address.city }} <br>
                        <span v-if="address.state">{{ address.state }},</span> {{ address.postal_code }}<br>
                        {{ address.country.name }}
                      </p>
                      <input type="radio" :value="address.id" v-model="addressId">
                      <div class="checkmark" v-if="addressId == address.id">
                        <i class="fa fa-check"></i>
                      </div>
                    </label>
                </div>
              </div>
              <div class="text-danger" v-if="selectionError">
                Please select an address
              </div>
              <template v-if="hasErrors">
                <br>
                <div class="alert alert-danger" v-for="(error, handle) in errors" :key="handle">
                  <div v-for="(error, index) in error" :key="index">
                    {{ error }}
                  </div>
                </div>
              </template>
              <hr>
            </template>
            <div class="row">
              <div class="col-xs-12 col-md-6">
                <div class="form-group">
                  <label :for="type + '_email'">Email</label>
                  <input :id="type + '_email'" type="email" class="form-control" v-model="address.email">
                  <span class="text-danger" v-for="(error, index) in getErrors('email')" :key="index">{{ error }}</span>
                </div>
              </div>
              <div class="col-xs-12 col-md-6">
                <div class="form-group">
                  <label :for="type + '_telephone'">
                    <span v-if="type == 'shipping'">
                      Delivery/Site Contact Number
                    </span>
                    <span v-else>
                      Telephone
                    </span>
                  </label>
                  <input :id="type + '_telephone'" type="tel" class="form-control" v-model="address.phone">
                  <span class="text-danger" v-for="(error, index) in getErrors('phone')" :key="index">{{ error }}</span>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-xs-12 col-md-6">
                <button class="btn btn-green" @click="save()" :disabled="processing">
                  <template v-if="!processing">
                    Confirm <span v-if="type == 'shipping'">Delivery</span><span v-else>Billing</span> Address
                  </template>
                  <template v-else>
                    <i class="fa fa-refresh fa-spin"></i> Saving
                  </template>
                </button>
              </div>
              <div class="col-xs-12 col-md-6" v-if="type == 'shipping'">
                <div class="shipping_toggle">
                  <label class="default-switch">
                      <input type="checkbox" v-model="sameAsBilling">
                      <span class="slider round"></span>
                  </label>
                  <span>Billing address is the same as shipping</span>
                </div>
              </div>
            </div>
          </template>
        </template>
    </div>
</template>

<script>
    import User from '../../Services/User.js';
    import Order from '../../Services/Order.js';
    import Checkout from '../../Services/Checkout.js';
    import Postcode from '../../Services/Postcode.js';

    export default {
        props: {
          enableSameShippingToggle: {
            type: Boolean,
            default: true
          },
          step: {
            default: 1
          },
          type: {
            default: 'shipping'
          },
          initialEmail: {
            default: null,
          },
          initialPhone: {
            default: null,
          },
          firstname: {
            default: null
          },
          lastname: {
            default: null
          },
          companyName: {
            default: null
          },
          country: {
            default: null
          },
          addressOne: {
            default: null
          },
          addressTwo: {
            default: null
          },
          addressThree: {
            default: null
          },
          city: {
            default: null
          },
          county: {
            default: null
          },
          zip: {
            default: null
          },
          phone: {
            default: null
          },
          email: {
            default: null
          }
        },
        data() {
            return {
                selectionError: false,
                useShipping: false,
                sameAsBilling: true,
                service: Order,
                checkout: Checkout,
                editing: true,
                processing: false,
                cachedAddress: null,
                errors: [],
                addresses: [],
                addressId: null,
                manual: true,
                users: User,
                lookups: [],
                address: {
                    company_name: null,
                    firstname: null,
                    lastname: null,
                    country: null,
                    address: null,
                    address_two: null,
                    address_three: null,
                    city: null,
                    county: null,
                    zip: null,
                    phone: null,
                    email: null
                }
            }
        },
        mounted() {
          this.setFromProps();
          this.service.setAddress(this.type, this.address, true);
          this.editing = this.incomplete;
          if ((!this.incomplete && this.checkout.step == this.step)) {
            this.checkout.next();
          }
          this.fetchAddresses();
        },
        methods: {
          goManual() {
            this.manual = true;
            this.addressId = null;
          },
          setFromProps() {
            this.address.firstname = this.firstname;
            this.address.company_name = this.companyName;
            this.address.address = this.addressOne;
            this.address.lastname = this.lastname;
            this.address.country = this.country;
            this.address.county = this.county;
            this.address.address_two = this.addressTwo;
            this.address.address_three = this.addressThree;
            this.address.city = this.city;
            this.address.zip = this.zip;
            this.address.phone = this.initialPhone ? this.initialPhone : this.phone;
            this.address.email = this.initialEmail ? this.initialEmail : this.email;
          },
          applyLookup(event) {
              let address = this.lookups[event.target.value];

              if(!address) {
                  return;
              }

              this.address.address = address.line_1;
              this.errors['address'] = null;
              this.address.country = 'United Kingdom';
              this.errors['country'] = null;
              this.address.county = address.county;
              this.errors['county'] = null;
              this.address.address_two = address.line_2;
              this.errors['address_two'] = null;
              this.address.address_three = address.line_3;
              this.errors['address_three'] = null;
              this.address.city = address.district;
              this.errors['city'] = null;
          },
          lookup() {
            this.lookups = [];
            this.errors['zip'] = null;
            Postcode.lookup(this.address.zip, (errors, addresses) => {
              if (!addresses.length) {
                this.errors['zip'] = 'Unable to find address';
              }
              this.lookups = addresses;
            });
          },
          fetchAddresses() {
            this.users.getAddresses().then(response => {
              this.addresses = _.filter(response.data, address => {
                return !!address.state
              });
              this.manual = this.addresses.length ? false : true;
              if (!this.manual) {
                this.addressId = this.addresses[0].id;
              }
            });
          },
          save: async function() {
            this.errors = [];
            if (this.address.country == 'United Kingdom' && !this.address.zip) {
              this.errors = {
                zip: ['Please enter your postcode']
              };
              this.processing = false;
              return;
            }

            if (!this.addressId && !this.manual) {
              this.selectionError = true;
              return;
            }
            this.selectionError = false;

            this.processing = true;
            const root = this;

            if (this.type == 'billing' || this.type == 'shipping' && this.sameAsBilling) {
              await this.service.setContact(this.address.email, this.address.phone).catch(errors => {
                this.errors = errors.errors;
                this.processing = false;
              });


              if (Object.keys(this.errors).length) {
                this.processing = false;
                return;
              }
            }

            if (this.addressId) {
              let address = _.find(this.addresses, address => {
                return address.id == this.addressId;
              });
              this.address.firstname = address.firstname;
              this.address.company_name = address.company_name;
              this.address.address = address.address;
              this.address.lastname = address.lastname;
              this.address.country = address.country.name;
              this.address.county = address.state;
              this.address.address_two = address.address_two;
              this.address.address_three = address.address_three;
              this.address.city = address.city;
              this.address.zip = address.postal_code;
            }

            this.service.setAddress(this.type, this.address, false, this.addressId)
            .then(response => {
              if (this.type == 'shipping' && this.sameAsBilling) {
                this.$emit('contact', {
                  email: this.address.email,
                  phone: this.address.phone,
                });

                this.service.setAddress('billing', this.address, false, this.addressId)
                .then(response => {
                  this.processing = false;
                  this.editing = false;
                  root.$emit('update_billing', this.address);
                  if (this.checkoutStep == this.step) {
                    this.checkout.next();
                  }
                });

              } else {
                this.processing = false;
                this.editing = false;
                if (this.checkoutStep == this.step) {
                  this.checkout.next();
                }
              }
              this.$emit('saved', this.address);
            }).catch(errors => {
              this.errors = errors.errors;
              this.processing = false;
            });
          },
          getErrors(handle) {
            return this.errors[handle];
          },
          choose(index) {
            let chosen = this.addresses[index];

            this.save(chosen.id);
          }
        },
        computed: {
          incomplete() {
            let incomplete = false;
            _.each(this.address, (item, handle) => {
              if (handle != 'phone' && handle != 'address_two' && handle != 'address_three' && handle != 'company_name' && !item) {
                console.log(handle)
                incomplete = true;
              }
            });
            return incomplete;
          },
          active() {
            return this.checkout.step >= this.step;
          },
          hasErrors() {
            return _.size(this.errors);
          },
          checkoutStep() {
            return this.checkout.step;
          }
        },
        watch: {
          checkoutStep(val) {
              if ((val == this.step) && !this.incomplete) {
                  this.checkout.next();
              }
          },
          addressOne: function (value) {
            this.setFromProps();
            this.editing = this.incomplete;
            if ((!this.incomplete && this.checkout.step == this.step)) {
              this.checkout.next();
            }
          },
          useShipping: function(value) {
            if (!this.cachedAddress) {
              this.cachedAddress = JSON.parse(JSON.stringify(this.address));
            }
            if (value) {
              this.address = JSON.parse(JSON.stringify(this.service.shippingAddress));
            } else {
              this.address = this.cachedAddress;
            }
          }
        }
    }
</script>

<style scoped lang="scss">
  .addres-choice-label {
    border:1px solid #dedede;
    display:block;
    padding:15px;
    position:relative;
    cursor:pointer;
    .checkmark {
      position:absolute;
      right:0;
      bottom:0;
      background-color:#003B77;
      color:white;
      padding:2px 4px;
    }
    input {
      display:none;
    }
    &.choice-active {
      border-color:#003B77;
    }
  }
  .shipping_toggle {
    margin-top:1em;
    display:flex;
    align-items: center;
    justify-content: flex-end
  }
  .default-switch {
    margin-bottom:0;
    margin-right:10px;
  }
</style>


// WEBPACK FOOTER //
// resources/assets/js/Components/Checkout/CheckoutAddress.vue